import { getContractDetails } from "../../api/contracts";
import store from "@/store";

const getDefaultState = () => {
    return { all: {} };
};

const state = getDefaultState();

const getters = {
    hasMobilitaetsSchutzPlus: (state) => {
        let result = false;
        for (let key in state.all) {
            if (
                state.all[key].MobilitaetsSchutzPlus &&
                state.all[key].MobilitaetsSchutzPlus === "aufrecht"
            ) {
                result = true;
            }
        }
        return result;
    },
};

const actions = {
    getContractDetails({ commit, state }, contractId) {
        return new Promise((resolve) => {
            if (!(contractId in state.all)) {
                commit("setLoading", true, { root: true });
            }
            getContractDetails(contractId)
                .then((response) => {
                    if (response.data.Status === 200) {
                        const result = response.data.Result;
                        commit("setDetails", {
                            contractId: contractId,
                            contract: result,
                        });
                        resolve();
                    } else {
                        store.cache.delete(
                            "contractsDetails/getContractDetails",
                            contractId
                        );
                    }
                })
                .catch(() => {
                    store.cache.delete(
                        "contractsDetails/getContractDetails",
                        contractId
                    );
                });
        });
    },
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setDetails(state, payload) {
        state.all = {
            ...state.all,
            [payload.contractId]: payload.contract.Details,
        };
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
